export default __webpack_public_path__ + "static/media/icon-cro.247c36d0.svg";